import React from 'react';
import { useId, useConst } from '@fluentui/react-hooks';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import PropTypes from 'prop-types';


export const EditableImageButton = (props) => {
  const {
    imageItem, i18n, baseImageId, onEdit,
  } = props;
  const tooltipId = useId('disableEditImageToolTip');
  const buttonId = useId('targetButton');
  const calloutProps = useConst({
    gapSpace: 0,
    target: `#${buttonId}`,
  });

  return (
    <React.Fragment>
      {
        !imageItem.disableEdit && <button
          aria-label={i18n.getString(_TL_('Edit Image'))}
          className="glyphicon glyphicon-pencil image-edit"
          onClick={onEdit}
          data-imageid={baseImageId}
        />
      }
      {
        imageItem.disableEdit &&
          <TooltipHost
            content={i18n.getString(_TL_('We don’t allow you to edit system-generated images.'))}
            id={tooltipId}
            calloutProps={calloutProps}
          >
            <button
              id={buttonId}
              aria-label={i18n.getString(_TL_('Edit Image'))}
              aria-describedby={tooltipId}
              className="glyphicon glyphicon-pencil image-edit is-recommended-image"
            />
          </TooltipHost>
      }
    </React.Fragment>
  );
};

EditableImageButton.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  baseImageId: PropTypes.string.isRequired,
  imageItem: PropTypes.shape({
    disableEdit: PropTypes.bool.isRequired,
  }).isRequired,
};

